import { Component, Input, OnInit } from '@angular/core'
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'

@Component({
  selector: 'app-porteur-identity-form',
  templateUrl: './porteur-identity-form.component.html',
  styleUrls: ['./porteur-identity-form.component.scss']
})
export class PorteurIdentityFormComponent implements OnInit {

  @Input()
  group: UntypedFormGroup

  constructor() { }

  ngOnInit() {
    this.group.addControl('lastname', new UntypedFormControl('', [
      Validators.required,
      Validators.pattern('^(?=.*[a-zA-Z0-9 \u0080-\u00ff^-]+)[a-zA-Z0-9 \u0080-\u00ff^-]+$')
    ]))
    this.group.addControl('firstname', new UntypedFormControl('', [
      Validators.required,
      Validators.pattern('^(?=.*[a-zA-Z0-9 \u0080-\u00ff^-\s]+)[a-zA-Z0-9 \u0080-\u00ff^-]+$')
    ]))
    this.group.addControl('function', new UntypedFormControl('', [
      //Validators.required
    ]))
    this.group.addControl('casier', new UntypedFormControl('', [
      //Validators.required
    ]))
    this.group.addControl('comment', new UntypedFormControl('', [
      //Validators.required
    ]))
  }

  get lastname(): AbstractControl {
    return this.group.get('lastname')
  }
  get firstname(): AbstractControl {
    return this.group.get('firstname')
  }
  get function(): AbstractControl {
    return this.group.get('function')
  }
  get casier(): AbstractControl {
    return this.group.get('casier')
  }
  get comment(): AbstractControl {
    return this.group.get('comment')
  }

}
